var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#757575"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07949 4.90147C9.24463 4.61444 9.61181 4.51545 9.89902 4.68037C10.1861 4.84547 10.285 5.21267 10.1201 5.49991L9.03652 7.38664H11.1998C11.5311 7.38664 11.7996 7.65543 11.7998 7.98665C11.7998 8.31802 11.5312 8.58665 11.1998 8.58665H9.02011L10.1201 10.5023C10.2851 10.7895 10.1861 11.1567 9.89902 11.3218C9.61168 11.4869 9.24454 11.3873 9.07949 11.1L7.99042 9.20541L6.92011 11.0703C6.75506 11.3576 6.38792 11.4572 6.10058 11.2921C5.81346 11.127 5.71449 10.7599 5.87949 10.4726L6.96308 8.58665H4.7998C4.46843 8.58665 4.1998 8.31802 4.1998 7.98665C4.19998 7.65543 4.46854 7.38664 4.7998 7.38664H6.94667L5.87949 5.5296C5.71458 5.24236 5.81348 4.87516 6.10058 4.71006C6.38779 4.54513 6.75497 4.64412 6.92011 4.93115L7.9912 6.79601L9.07949 4.90147Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinked);
export default ForwardRef;